import { render } from "./index.vue?vue&type=template&id=1b1176c0&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=1b1176c0&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1176c0"]])

export default __exports__